module.exports = __webpack_public_path__ + "static/media/AZ-logo.92498cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AZ-logo.png
// module id = 1370
// module chunks = 0